import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import React from "react";
import Loading from "../loader/loader";

const ConformationPopup = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to map this category ?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          color="primary"
          onClick={props.onFinish}
        >
          {props.maploading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
        <Button
          // variant="outline-primary"
          // color="primary"
          onClick={() => props.onClose()}
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConformationPopup;
